module.exports = __webpack_public_path__ + "media/images/icon_foal_mare-46debb676c8db9406562bd0912b0aaad.png";